module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-04@2x.cade1ef6.jpg";